import { createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4675e865")

_pushScopeId("data-v-4675e865")
const _hoisted_1 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("span", { class: "donut" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    name: "fade-in",
    appear: ""
  }, {
    default: _withId(() => [
      _hoisted_1
    ]),
    _: 1
  }))
})